<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>العهدة</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة عهدة</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.ohda"
                        label=" العهدة"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.emp_to"
                        label="الشخص المستلم "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="number"
                        v-model="newItem.money"
                        label="المبلغ"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.notes"
                        label="ملاحظات "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل العهدة</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.ohda"
                      label="العهدة "
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.emp_to"
                      label="الشخص المستلم "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.money"
                      type="number"
                      label="المبلغ  "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.notes"
                      label="ملاحظات "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="ohdas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.tasfia == 0
                ? { 'background-color': 'yellow' }
                : { 'background-color': 'white' }
            ]"
          >
            <td>{{ props.item.ohda }}</td>
            <td class="text-xs-right">{{ props.item.emp_to }}</td>
            <td class="text-xs-right">{{ props.item.money }}</td>
            <td class="text-xs-right">{{ props.item.notes }}</td>
            <td class="text-xs-right">{{ props.item.user.name }}</td>
            <td class="text-xs-right">
              {{ props.item.tasfia == 0 ? "لم يتم التصفية" : "تمت التصفية" }}
            </td>
            <td class="justify-center layout px-0">
              <v-icon
                v-if="permissions.delete_all == 1 || user.type == 1"
                small
                class="ml-4"
                @click="editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                v-if="permissions.delete_all == 1 || user.type == 1"
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon>
              <v-btn
                color="success"
                :disabled="props.item.tasfia != 0"
                @click="tasfia(props.item)"
                >تصفية العهدة</v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  ohdas,
  add_ohda,
  update_ohda,
  delete_ohda,
  add_tasfia,
  branches
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " العهدة",
        align: "right",
        value: "name"
      },
      { text: " الشخص المستلم", value: "address", align: "right" },
      { text: " المبلغ", value: "rasid", align: "right" },
      { text: " ملاحظات", value: "rasid", align: "right" },
      { text: " المسئول", value: "rasid", align: "right" },
      { text: " الحالة", value: "rasid", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    select_branch: { id: "", job_name: "", name: "أختر الفرع" },
    select_branch_edit: { id: "", job_name: "", name: "أختر الفرع" },
    search: "",
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    ohdas: [],
    branchs: [],
    editedItem: {
      id: "",
      ohda: "",
      emp_to: "",
      money: "",
      notes: "",
      user_id: ""
    },
    newItem: {
      id: "",
      ohda: "",
      emp_to: "",
      money: "",
      notes: "",
      user_id: ""
    }
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.ohdas.length > 0) {
        return (this.code =
          parseInt(this.ohdas[this.ohdas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
    this.myohdas();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branchs = response.data;
      });
    },
    myohdas() {
      ohdas().then(response => {
        this.ohdas = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
      });
    },
    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      let myUser = JSON.parse(localStorage.getItem("user"));
      this.editedIndex = this.ohdas.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.ohda = item.ohda;
      this.editedItem.emp_to = item.emp_to;
      this.editedItem.money = item.money;
      this.editedItem.notes = item.notes;
      this.editedItem.user_id = myUser.id;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.ohdas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_ohda(frmData2, item.id).then(response => {
            this.loading = false;
            this.ohdas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    tasfia(item) {
      this.$swal({
        title: "هل تريد تصفية العهدة",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          add_tasfia(item.id).then(response => {
            this.loading = false;
            this.myohdas();
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.user_id = myUser.id;
          var frmData = new FormData();
          frmData.append("ohda", JSON.stringify(this.newItem));

          add_ohda(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_branch, this.$options.data().select_branch);

            this.ohdas.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          var frmData = new FormData();
          frmData.append("ohda", JSON.stringify(this.editedItem));
          update_ohda(frmData, item_id).then(response => {
            Vue.set(
              this.ohdas,
              this.ohdas.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
